import * as React from "react";
import { ImageList, ImageListItem } from "@mui/material";
import GenerateThumbnail from "../Popup/GenerateThumbnail";
import ListSubheader from "@mui/material/ListSubheader";
import { makeStyles } from "@mui/styles";

export default function PackShotAndThumbnail(selectedThumbnailsToMarkCorrect) {
  const selectedThumbnails =
    selectedThumbnailsToMarkCorrect.selectedThumbnailsToMarkCorrect;

  const useStyles = makeStyles((theme) => ({
    customWidth: {
      maxWidth: "13vw",
    },
  }));

  return (
    <>
      <ImageList
        className="annotator-sidebar"
        sx={{
          border: "1px solid #d7f3ff",
          borderRadius: "4px",
          maxWidth: "50%",
          cursor: "default",
          flex: "1",
          padding: "0.5rem",
          boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;",
          backgroundColor: "transparent",
          //height: 230,
          '@media screen and (max-height: 830px)': {
            height: 180, 
          },
          '@media screen and (max-height: 930px)': {
            height: 200, 
          },
          '@media screen and (max-height: 990px)': {
            height: 205, 
          },
          '@media screen and (max-height: 1110px)': {
            height: 190, 
          },
        }}
      >
        <ImageListItem key="Subheader" cols={2}>
          <ListSubheader
            component="div"
            style={{
              fontSize: "0.8rem",
              lineHeight: "1.1rem",
              textAlign: "center",
              backgroundColor: "#f6f8fa",
              fontFamily: "ChalkboardSE-Regular",
            }}
          >
            selected thumbnails
          </ListSubheader>
        </ImageListItem>

        {selectedThumbnails.map((data, index) => (
          <ImageListItem key={index}>
            <GenerateThumbnail data={data} type="savethumbnail" />
          </ImageListItem>
        ))}
      </ImageList>
    </>
  );
}
